module.exports = __webpack_public_path__ + "static/media/yt.5c41db5e.svg";